import React,{useState, useEffect}  from 'react';
import Table from 'react-bootstrap/Table';
import Sides from '../Bars/Cppsidebar';
import { Helmet } from "react-helmet";
import Button from 'react-bootstrap/Button'
function Ckeyword(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  

return(
    <div>
      
      <Sides/>
       <Helmet>
 
 <title>C++ keyword tutorial For Beginners</title>
 <meta name="description" content="C++ keyword tutorial for beginners.There are 95 Types of Keyword in C++ Programming Language. CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,C++ keyword tutorial for beginners,programming language tutorial for begineers,learn code in free,c++ programming tutorial for beginners,learn code in free online,cpp keyword,cpp keyword extern,c++ keyword static,c++ keywords,cpp keyword volatile,volatile keyword c++,c++ define keyword,c++ final keyword,c++ language keywords list,how many keyword in cpp language,c++ keywords and identifiers" />
 <link rel="canonical" href="https://www.codeexampler.com/cpp-keyword" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">keyword in C++</h1>
    <div className="first">
        <a href="/cpp-element">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-identifier">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2"> C++ Keyword in Programming Language</h2>
<p className="mt-4 para">1, There are 95 Reserved Keyword in C++ Programming Language.<br/>
2, C++ keywords are Known as Reserved Words.<br/>
3, These Keywords are Not used in Variable Name means These keywords cannot use as identifiers.<br/>
4, They cannot use as names for a variable, class, or method.</p>
  <h2 className="mt-4 mh2">C++ Programming Keyword Table</h2>
    <Table striped bordered hover responsive variant="dark m-4">

  <tbody>

  <tr>
    
    <td>else</td>
    <td>enum</td>
    <td>explicit</td>
    <td>export</td>
  
  </tr>

    <tr>
    
      <td>extern</td>
      <td>false</td>
      <td>float</td>
      <td>for</td>
    
    </tr>
    <tr>
    
      <td>friend</td>
      <td>goto</td>
      <td>if</td>
      <td>inline</td>
      
    </tr>
    <tr>
    
      <td>int</td>
      <td>long</td>
      <td>mutable</td>
      <td>namespace</td>
      
    </tr>

    <tr>
    
      <td>asm</td>
      <td>auto</td>
      <td>bool</td>
      <td>break</td>
      
    </tr>

    <tr>
    
      <td>case</td>
      <td>catch</td>
      <td>char</td>
      <td>class</td>
     
    </tr>

    <tr>
    
      <td>const</td>
      <td>const cast</td>
      <td>continue</td>
      <td>default</td>
      
      
    </tr>

    <tr>
    
      <td>delete</td>
      <td>do</td>
      <td>double</td>
      <td>dynamic cast</td>
      
    </tr>



    <tr>
    
      <td>new</td>
      <td>opeartor</td>
      <td>private</td>
      <td>protected</td>
    
    </tr>
    <tr>
    
      <td>public</td>
      <td>register</td>
      <td>reinterpret cast</td>
      <td>return</td>
      
    </tr>
    <tr>
    
      <td>short</td>
      <td>signed</td>
      <td>sizeof</td>
      <td>static</td>
      
    </tr>

    <tr>
    
      <td>static_cast</td>
      <td>struct</td>
      <td>switch</td>
      <td>template</td>
      
    </tr>

    <tr>
    
      <td>this</td>
      <td>throw</td>
      <td>true</td>
      <td>typeedef</td>
     
    </tr>

    <tr>
    
      <td>typeid</td>
      <td>typename</td>
      <td>union</td>
      <td>unsigned</td>
      
      
    </tr>

    <tr>
    
      <td>using</td>
      <td>virtual</td>
      <td>void</td>
      <td>volatile</td>
      
    </tr>

    <tr>
    
      <td>wchar_t</td>
      <td>while</td>
    
      
    </tr>


  </tbody>
</Table>
<h2 className="mt-4 mh2">In addition, few Keywords also.</h2>

<Table striped bordered hover responsive variant="dark m-4">

  <tbody>
    <tr>
      
      <td>bitor</td>
      <td>compl</td>
      <td>not</td>
      <td>not_eg</td>
    
    </tr>
    <tr>
      
      <td>or</td>
      <td>or_eq</td>
      <td>xor</td>
      <td>xor_eq</td>
      
    </tr>

    <tr>
     
      <td>and</td>
      <td>and_eq</td>
      <td>bitand</td>
    
      
    </tr>

  </tbody>
</Table>



<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/cpp-element">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-identifier">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div> </div>
)

}
export default Ckeyword;